// extracted by mini-css-extract-plugin
export var box = "SocialMediaIcon-module--box--1092d";
export var box_md = "SocialMediaIcon-module--box_md--ff7cb";
export var box_xmd = "SocialMediaIcon-module--box_xmd--b10bd";
export var box_flex = "SocialMediaIcon-module--box_flex--d4cff";
export var box_lg = "SocialMediaIcon-module--box_lg--3c771";
export var box_sm = "SocialMediaIcon-module--box_sm--479bd";
export var box_outer = "SocialMediaIcon-module--box_outer--e1ec9";
export var box_whiteBg = "SocialMediaIcon-module--box_white-bg--a68ef";
export var box_noMarginBottom = "SocialMediaIcon-module--box_no-margin-bottom--35c1e";
export var box_noPadding = "SocialMediaIcon-module--box_no-padding--bc0e5";
export var box_outerGray = "SocialMediaIcon-module--box_outer-gray--7aac3";
export var box_dark = "SocialMediaIcon-module--box_dark--0b1eb";
export var box_zIndex = "SocialMediaIcon-module--box_z-index--a4cad";
export var box_zIndex6 = "SocialMediaIcon-module--box_z-index-6--8483a";
export var box_eventsWithLine = "SocialMediaIcon-module--box_events-with-line--5fef2";
export var box_featuresAo = "SocialMediaIcon-module--box_features-ao--922bf";
export var box_verticalPaddings = "SocialMediaIcon-module--box_vertical-paddings--ae894";
export var clearP = "SocialMediaIcon-module--clearP--012cf";
export var clearP_vc = "SocialMediaIcon-module--clearP_vc--7efc0";
export var link = "SocialMediaIcon-module--link--50d18";
export var icon = "SocialMediaIcon-module--icon--e1852";
export var slimFooter = "SocialMediaIcon-module--slimFooter--816d8";
export var fadeInAnimation = "SocialMediaIcon-module--fadeInAnimation--4e7a8";
export var placeHolderShimmer = "SocialMediaIcon-module--placeHolderShimmer--dd1be";